var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrustLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.8 0C18.56 0 20 1.44 20 3.2v13.6c0 1.76-1.44 3.2-3.2 3.2H3.2A3.21 3.21 0 0 1 0 16.8V3.2C0 1.44 1.44 0 3.2 0h13.6zm0 1.2H3.2c-1.1 0-2 .9-2 2v13.6c0 1.1.9 2 2 2h13.6c1.1 0 2-.9 2-2V3.2c0-1.1-.9-2-2-2zm-1 3.38c.08 0 .14.06.14.14V8.2c0 .08-.06.14-.14.14h-3.54c-.08 0-.14.06-.14.14v6.74c0 .08-.06.14-.14.14H8.04c-.08 0-.14-.06-.14-.14V8.5c0-.1-.08-.18-.18-.18H4.2c-.08 0-.14-.06-.14-.14V4.72c0-.08.06-.14.14-.14h11.6z",
  fill: "#666"
})));
export default SvgTrustLogo;